import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.esm';
// import { required, min, max } from 'vee-validate/dist/rules.esm';

// Add the rules you need.
// Validator.extend('required', required);
// Validator.extend('min', min);
// Validator.extend('max', max);

export { Validator };
export default VeeValidate;
